var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-review mt-n2"},[_c('index-view',{attrs:{"title":"Danh sách nhân viên","filters":_vm.filters,"getData":_vm.getData,"headers":_vm.mainHeaders},scopedSlots:_vm._u([{key:"viewSection",fn:function({ item }){return [_c('detail',{attrs:{"item":item}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }